import { Box } from "@mui/material";
import StudioChip from "./components/StudioChip";

interface StudioFilterProps {
  studioIds: string[];
}

const StudioFilter: React.FC<StudioFilterProps> = ({ studioIds }) => {
  const sixStudioIds = studioIds.slice(0, 6);
  const hasMoreStudios = studioIds.length > 6;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        marginTop: 1,
        marginBottom: 3,
      }}
    >
      {sixStudioIds.map((studioId) => (
        <StudioChip key={studioId} studioId={studioId} />
      ))}
      {hasMoreStudios && (
        <Box
          sx={{
            height: 34,
            borderRadius: "8px",
            backgroundColor: "rgb(8, 16, 55)",
            display: "flex",
            alignItems: "center",
            padding: "0 12px",
            color: "white",
            fontSize: "14px",
          }}
        >
          +{studioIds.length - 10}
        </Box>
      )}
    </Box>
  );
};

export default StudioFilter;
